import { FC } from "react";
import { ActivityDataWithType } from "../types";
import {
  ChequeActivity,
  ChequeActivityAction,
  ChequeActivityDataWithMeta,
} from "./types";
import Container, { EmptyContainer } from "../../meta-container";
import ChequeConfirmActivity from "./cheque-confirm-activity";
import ChequeDeleteActivity from "./cheque-delete-activity";
import ChequeDeliverActivity from "./cheque-deliver-activity";
import ChequeUpdateActivity from "./cheque-update-activity";

const ChequeActivityRenderer: FC<ActivityDataWithType> = ({
  activity,
  by,
  date,
  type,
}) => {
  const activity_ = activity as ChequeActivity;
  return (
    <Container<ChequeActivityAction, ChequeActivityDataWithMeta>
      data={{ by, date, type, activity: activity_.data }}
      type={activity_.action}
      match={{
        [ChequeActivityAction.None]: EmptyContainer,
        [ChequeActivityAction.Confirm]: ChequeConfirmActivity,
        [ChequeActivityAction.Delete]: ChequeDeleteActivity,
        [ChequeActivityAction.Deliver]: ChequeDeliverActivity,
        [ChequeActivityAction.Update]: ChequeUpdateActivity,
      }}
    />
  );
};

export default ChequeActivityRenderer;
